import React from 'react';
import { Link } from 'react-router-dom';

const GITHUB_USERNAME = 'Something-Comicallyfunny';
const AVATAR_URL = `https://github.com/${GITHUB_USERNAME}.png`;

export default function Home() {
  return (
    <div style={{ paddingTop: '6rem', display: 'flex', justifyContent: 'center' }}>
      <div className="glass-card" style={{ maxWidth: 840, width: '100%', padding: 32 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <div style={{ width: 128, height: 128, borderRadius: '50%', overflow: 'hidden', marginBottom: 16, boxShadow: '0 6px 24px rgba(0,0,0,0.35)' }}>
            <img src={AVATAR_URL} alt="GitHub avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <h1 className="title" style={{ margin: 0 }}>Ezra Dixon</h1>
          <p className="subtitle" style={{ marginTop: 6, marginBottom: 16 }}>aka Something Comical</p>
          <p className="body-text" style={{ maxWidth: 720, marginBottom: 20 }}>
            Developer, audio / lighting tech, and aviation enthusiast. I build effects for Microsoft Flight Simulator
            with the TriTriSim TFX team, tinkerer with frontends/backends, and love making things look and sound great.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link className="btn-glass-primary" to="/about">About me</Link>
            <Link className="btn-glass-secondary" to="/liveries">Liveries</Link>
            <Link className="btn-glass-secondary" to="/profile">Your Profile</Link>
            <Link className="btn-glass-secondary" to="/forums">Forums</Link>
            <a className="btn-glass-secondary" href={`https://github.com/${GITHUB_USERNAME}`} target="_blank" rel="noreferrer">GitHub</a>
          </div>
        </div>
      </div>
    </div>
  );
}
